// Shared class-schedule helpers. Weekdays are ISO: 1=Mon … 7=Sun. "Today" is pinned to
// Asia/Ho_Chi_Minh (GMT+7) so the UI agrees with the server cron regardless of device tz.

export const WEEKDAYS = [
    { iso: 1, label: 'Thứ 2' },
    { iso: 2, label: 'Thứ 3' },
    { iso: 3, label: 'Thứ 4' },
    { iso: 4, label: 'Thứ 5' },
    { iso: 5, label: 'Thứ 6' },
    { iso: 6, label: 'Thứ 7' },
    { iso: 7, label: 'Chủ nhật' },
];

const ISO_BY_SHORT = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

export function weekdayLabel(iso) {
    const w = WEEKDAYS.find(x => x.iso === iso);
    return w ? w.label : '';
}

/** ISO weekday (1–7) right now, as observed in Vietnam. */
export function currentIsoWeekdayVN(date = new Date()) {
    const short = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Ho_Chi_Minh',
        weekday: 'short',
    }).format(date);
    return ISO_BY_SHORT[short];
}

/** "18:00" + 90 → "19:30". Returns '' if start is malformed. */
export function endTime(start, durationMin) {
    const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(start || '');
    if (!m) return '';
    const total = (Number(m[1]) * 60 + Number(m[2]) + (Number(durationMin) || 0)) % (24 * 60);
    const hh = String(Math.floor(total / 60)).padStart(2, '0');
    const mm = String(total % 60).padStart(2, '0');
    return `${hh}:${mm}`;
}

/** Read-only "Thứ 2 18:00–19:30, Thứ 6 09:00–10:30" from a class's schedule_slots. */
export function formatSlots(slots) {
    if (!Array.isArray(slots) || slots.length === 0) return '';
    return slots
        .slice()
        .sort((a, b) => (a.weekday - b.weekday) || (a.start || '').localeCompare(b.start || ''))
        .map(s => {
            const end = endTime(s.start, s.duration_min);
            return `${weekdayLabel(s.weekday)} ${s.start}${end ? `–${end}` : ''}`.trim();
        })
        .join(', ');
}

const byStart = (a, b) => (a.slot.start || '').localeCompare(b.slot.start || '');

/** Non-archived {class, slot} pairs for one ISO weekday, sorted by start time. */
export function classesToday(classes, isoWeekday) {
    const out = [];
    for (const cls of classes || []) {
        if (cls.archived) continue;
        for (const slot of cls.schedule_slots || []) {
            if (slot.weekday === isoWeekday) out.push({ cls, slot });
        }
    }
    return out.sort(byStart);
}

/** { iso → [{class, slot}] } for all 7 days, each sorted by start. Skips archived. */
export function expandWeek(classes) {
    const week = {};
    for (const { iso } of WEEKDAYS) week[iso] = [];
    for (const cls of classes || []) {
        if (cls.archived) continue;
        for (const slot of cls.schedule_slots || []) {
            if (week[slot.weekday]) week[slot.weekday].push({ cls, slot });
        }
    }
    for (const iso of Object.keys(week)) week[iso].sort(byStart);
    return week;
}
